import React from 'react';
import { useLanguage, type Lang } from '../hooks/useLanguage';
import { theme as T } from '../theme';

interface Props {
  compact?: boolean;
}

export function LanguageSwitcher({ compact = false }: Props) {
  const { lang, setLanguage } = useLanguage();

  const btn = (l: Lang, label: string) => (
    <button
      key={l}
      onClick={() => setLanguage(l)}
      style={{
        padding: compact ? '3px 7px' : '4px 10px',
        fontSize: compact ? 11 : 12,
        fontWeight: lang === l ? 700 : 400,
        color: lang === l ? T.accent : T.textDim,
        background: lang === l ? T.accentGlow : 'transparent',
        border: `1px solid ${lang === l ? T.accent : T.border}`,
        borderRadius: 5,
        cursor: 'pointer',
        transition: 'all 0.15s',
        fontFamily: T.fontSans,
      }}
    >
      {label}
    </button>
  );

  return (
    <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
      {btn('en', 'EN')}
      {btn('pt', 'PT')}
    </div>
  );
}
